
import { Skeleton, SkeletonItem } from "element-ui"
import ware from "./ware"
import { trackViewItemList } from "@/utils/track"
import ObserverHOC from "@/components/ObserverHOC"
import { handleGetCartDetailV2CardClass } from "@/utils/cartResponse"
// import { ware } from 'ui-library-web';

// 将数组数据分行
function arrayToRow(arr, row) {
  if (!arr) return []
  const result = []
  let output = []
  for (let i = 0; i < arr.length; i++) {
    arr[i].index = i % row
    if (i % row === 0 && i !== 0) {
      result.push([...output])
      output = [arr[i]]
    } else {
      output.push(arr[i])
    }
  }
  result.push([...output])
  return result
}

export default {
  name: "WareViewList",
  components: {
    [Skeleton.name]: Skeleton,
    [SkeletonItem.name]: SkeletonItem,
    ware,
    ObserverHOC
  },
  props: {
    rowNum: {
      type: Number,
      default: 5
    },
    wareList: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    categoryArr: {
      type: Array,
      default: () => []
    },
    itemListName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      list: [],
      cartList: []
    }
  },

  computed: {},
  watch: {
    wareList: {
      handler(newVal) {
        if (!newVal) return
        const addCategory = newVal.map(v => {
          v.categoryArr = this.categoryArr
          return v
        })
        this.list = arrayToRow(addCategory, this.rowNum)
        // 只有 cartList 非空时才调用 handleCartList
        if (Array.isArray(this.cartList) && this.cartList.length > 0) {
          this.handleCartList(this.cartList)
        }
      },
      immediate: true
    }
  },

  mounted() {
    this.$bus.$on("getCartSkuList", this.handleCartList)
  },
  beforeDestroy() {
    this.$bus.$off("getCartSkuList", this.handleCartList)
  },
  methods: {
    goodsNummberShow(item) {
      this.list = this.list.map(innerArray => innerArray.map(obj => (obj.sku === item.sku ? { ...item } : obj)))
    },
    handleCartList(val = []) {
      this.cartList = Array.isArray(val) ? val : [] // 强制转为数组
      // 获取count
      this.list = this.list.map(item =>
        item.map(ele => {
          const count = this.cartList.find(_v => _v.sku == ele.sku)
            ? this.cartList.find(_v => _v.sku == ele.sku).count
            : 0
          // eslint-disable-next-line no-unneeded-ternary
          const goodsNummberShow = count ? true : false
          return { ...ele, count, goodsNummberShow }
        })
      )

      console.log("====================================")
      console.log(this.list, "3232")
      console.log("====================================")
    },
    handleVisibility(target, index) {
      trackViewItemList(this.list[index], this.itemListName, this.itemListName)
    }
  }
}
